import { EntityQuery } from 'breeze-client';
import { GroupPrincipal } from '../../models';

const baseQuery = EntityQuery.from('Groups');

export const groupQueries = {
  selectAll: baseQuery.orderBy([GroupPrincipal.propName('name')])
};
